import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

// Logo URLs
const LOGO_FULL = "https://customer-assets.emergentagent.com/job_secure-parcels/artifacts/9xfoqgv2_LOKKER%20PRINCIPAL.png";
const LOGO_ICON = "https://customer-assets.emergentagent.com/job_secure-parcels/artifacts/9xfoqgv2_LOKKER%20PRINCIPAL.png";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Como Funciona', path: '/#como-funciona' },
    { name: 'Planos', path: '/planos' },
    { name: 'Condomínios', path: '/condominios' },
    { name: 'Empresas', path: '/empresas' },
    { name: 'Mapa', path: '/mapa' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path.replace('/#', ''));
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-lokker-blue/95 backdrop-blur-sm border-b border-lokker-blue">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <img 
              src={LOGO_FULL} 
              alt="Use Lokker" 
              className="h-10 lg:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`font-medium text-sm transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-lokker-lime'
                    : 'text-white/80 hover:text-lokker-lime'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link to="/planos">
              <Button
                data-testid="navbar-cta-button"
                className="bg-lokker-lime text-black font-bold px-6 py-2 rounded-sm hover:bg-lokker-lime-dark transition-all shadow-[3px_3px_0px_0px_rgba(0,0,0,0.3)] hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,0.3)] hover:translate-y-[2px]"
              >
                Começar Agora
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-white"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-lokker-blue border-t border-lokker-lime/20">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`block py-2 font-medium ${
                  isActive(link.path)
                    ? 'text-lokker-lime'
                    : 'text-white/80'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/planos" onClick={() => setIsOpen(false)}>
              <Button
                data-testid="mobile-cta-button"
                className="bg-lokker-lime text-black font-bold w-full mt-4 rounded-sm"
              >
                Começar Agora
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
